import { TaskmapProduct } from "./taskmap";

export type Machine = {
  id: string;
  product: TaskmapProduct;
};

export type MachineList = Array<Machine>;

const Machines: MachineList = [
  {
    id: "munckhof_trailed_sprayer",
    product: TaskmapProduct.BLOSSOM,
  },
  {
    id: "munckhof_root_pruner",
    product: TaskmapProduct.VIGOUR,
  },
  {
    id: "boreko_root_pruner",
    product: TaskmapProduct.VIGOUR,
  },
  {
    id: "kwh_sprayer",
    product: TaskmapProduct.BLOSSOM,
  },
];

export default function getMachines(product: TaskmapProduct): MachineList {
  return Machines.filter((machine) => machine.product === product);
}
